import React from 'react'
import { postInsertUserContratosxEmpresa } from '../../../services/PaginaRuta'

const TablaListaSeleccionContratosPorEmpresa = ({item,tipoDocumento,nombre,numeroDocumento,passActualizar,cerrarmodal}) => {
  const info={
    MENNIT: item.MENNIT,
    MPTDoc: tipoDocumento,
    MPCedu: numeroDocumento,
    MTCodP: item.MTCodP,
    MTUCod: item.MTUCod
  }
  const handleOnclickguardar=()=>{
    //postInsertUserContratosxEmpresa(info).then((res)=>passdatoscontratosxempresa(info))
    postInsertUserContratosxEmpresa(info).then((res)=>{
      console.log(res.data)
      passActualizar(info)
      cerrarmodal(info)
    })
    
  }
  return (
    <tr className="border-b" >
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        <button
        onClick={handleOnclickguardar}
          type="button"
          className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
        >
          Seleccionar
        </button>
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        {item.MENNIT}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        {item.MENOMB}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">
        {item.MTUCo1}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">
        {item.MTCodP}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        {item.MTNomP}
      </td>
    </tr>
  )
}

export default TablaListaSeleccionContratosPorEmpresa